import React from "react";
import Movieinfo from "../component/movieDetails/movieinfo";

const MovieDetails = ({ movies2 }) => {
  return (
    <div>
      <Movieinfo moviess={movies2} />
    </div>
  );
};

export default MovieDetails;
